import React, { Component } from 'react'
import { Card } from '@myxplor/ui'

import List from '../ui/list'
import LocalAsyncStore from '../local-async-store'
import GovRegistration from './details'
import GovRegistrationsList from './views'
import NoGovRegistrations from './views/empty'

export const filterShape = record => {
  const names = (record.name || '').split(' ')
  let output = {
    type: record.type,
    status: record.show_migration_pending ? 'pending' : null,
  }

  names.forEach((val, i) => {
    output[`name_${i}`] = names.slice(i, names.length).join(' ')
  })

  return output
}

export class GovRegistrations extends Component {
  render() {
    const { reg_holders, base_url, embedded = false } = this.props

    return (
      <Card
        title={
          <div className="currentService--wrapper">
            <div className="currentService--type">Listing all</div>
            Gov Registrations
          </div>
        }
        embedded={embedded}>
        <List
          base_url={base_url}
          records={reg_holders.data}
          loading={reg_holders.loading}
          listComponent={GovRegistrationsList}
          detailComponent={GovRegistration}
          emptyComponent={NoGovRegistrations}
          filterOn={filterShape}
        />
      </Card>
    )
  }
}

export default LocalAsyncStore('reg_holders', GovRegistrations, () => '/api/registration-holders')



// WEBPACK FOOTER //
// ./src/gov-registrations/container.js